import React from 'react';

const Divider = () => (
  <div className="tw-h-[1px] tw-w-full tw-bg-grayscale-20" />
);

export default Divider;
